import { useCallback, useEffect, useRef, useState } from "react";
import { productDirectoryAlgoliaService } from "../services/productDirectoryAlgoliaService";
import { ProductStoreProduct } from "../api/fetchProductStoreProducts/types";

export function useProductDirectoryPage() {
  const [products, setProducts] = useState<ProductStoreProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [categoryFacets, setCategoryFacets] = useState<Record<string, number>>(
    {},
  );
  const [typeFacets, setTypeFacets] = useState<Record<string, number>>({});

  const searchRequestRef = useRef(0);
  const hasMore = products.length < totalCount;

  useEffect(() => {
    const requestId = ++searchRequestRef.current;
    setLoading(true);
    setPage(0);

    const filters: Record<string, string> = {};
    if (selectedCategory) filters.categoryName = selectedCategory;
    if (selectedType) filters.type = selectedType;

    productDirectoryAlgoliaService
      .searchProducts(searchInput.trim(), filters, 0)
      .then((result) => {
        if (requestId !== searchRequestRef.current) return;
        setProducts(result.hits);
        setTotalCount(result.totalCount);
        setCategoryFacets(result.facets.categories);
        setTypeFacets(result.facets.types);
      })
      .finally(() => {
        if (requestId === searchRequestRef.current) {
          setLoading(false);
        }
      });
  }, [searchInput, selectedCategory, selectedType]);

  const fetchMore = useCallback(() => {
    const nextPage = page + 1;
    setPage(nextPage);

    const filters: Record<string, string> = {};
    if (selectedCategory) filters.categoryName = selectedCategory;
    if (selectedType) filters.type = selectedType;

    productDirectoryAlgoliaService
      .searchProducts(searchInput.trim(), filters, nextPage)
      .then((result) => {
        setProducts((prev) => [...prev, ...result.hits]);
        setTotalCount(result.totalCount);
        setCategoryFacets(result.facets.categories);
        setTypeFacets(result.facets.types);
      });
  }, [page, searchInput, selectedCategory, selectedType]);

  return {
    products,
    loading,
    searchInput,
    setSearchInput,
    selectedCategory,
    setSelectedCategory,
    selectedType,
    setSelectedType,
    totalCount,
    categoryFacets,
    typeFacets,
    hasMore,
    fetchMore,
  };
}
